<div class="job-posts placements agreements margin-top-service-30px">
  <div class="card skillassest-form">
    <!--<div class="card-header wh-header card-title-schedule-bb card-title-schedule-bl padding-l-8px  padding-bottom padding-top-5">
      Services Configuration
    </div>-->



  </div>
  <div class="card-body padding-top padding-left-0px padding-right-0px">
    <div class="row">

      <div class="position-fixed-service border-right2 padding-right-0px">
        <div class="card">

          <div class="card-header wh-header header3 padding-right-32px bk-color-light">
            <div class="row margin-top10px margin-left-20px card-title-schedule-bb nav-link-hand" (click)="BackToServices()">
             
              <label class="wh-header padding-left-5px font-weight-normal card-title-schedule-bl border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px">
                Users</label>
                <!--<a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Services"
                    *ngIf="ShowIcon"><i class="fas fa-angle-double-left font-size-19px"></i></a>-->
             
            </div>
          



          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-bottom-0px">
            <div class="row border-top border-bottom padding-top-10px padding-bottom-10px margin-right-0px margin-left16px">
              <div class="col-md-10 padding-right-0px padding-left-0px margin-left-17px">
                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
              </div>
              <div class="col-md-2" hidden>
                <button type="button"  class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
              </div>
              <div class="col-md-1 padding-left-8px" hidden>
                <a  class="nav-link-hand education-navlink" tooltip="Edit">
                  <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                </a>

              </div>
              <div class="col-md-1 padding-left-8px" hidden>
                <a class="nav-link-hand education-navlink" tooltip="Delete">
                  <span class="badge font-size-14">
                    <i class="far fa-trash-alt"></i>
                  </span>
                </a>
              </div>

            </div>
            <div>
              <div class="chatsd product-chart-wrapper product-chat-height-557 agreement-chart-wrapper ps2 padding-lrt ">
                <div class="row rowfor2 margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px"
                     *ngFor="let l of pdata" (click)="DoctorListItemSelected(l)">
                  <div class="col-md-12 margin-top-5px margin-bottom-5px">

                    <div class="row">
                      <div class="col-md-3">
                        <div class="row">
                          <a class="nav-link-hand margin-left-5px">
                            <img class="user-image-circle-65px img2" [src]="l.ActorImageFile" onError="this.src='dummy.jpg';">
                          </a>
                        </div>
                      </div>
                      <div class="col-md-9 padding-left-0px">
                        <div class="row ">
                          <div class="col-md-8">
                            <label class="margin-bottom-0px f2">{{l.UserName}}</label>
                          </div>
                         
                        </div>

                        <div class="row margin-left-0px">
                          <label class="margin-bottom-0px f3">{{l.DisplayName}}</label>
                        </div>

                      </div>

                    </div>






                  </div>
                </div>

            



              </div>
            </div>

          </div>
          
        </div>
      </div>
      <div class="offset-md-2 col-md-10" *ngIf="ShowService">
        <div class="card">

        </div>
        <div class="row" *ngIf="SelectedDoctorData">
          <div class="col-md-12 padding-left-0px">
            <div class="card">
              <div class="card-header">
               
                <div class="row">
                  <div class="col-md-1">
                    <a class="user-image-circle-65px">
                      <img class="img3" [src]="SelectedDoctorData.ActorImageFile" onError="this.src='dummy.jpg';">
                    </a>
                  </div>
                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">{{SelectedDoctorData.DisplayName}}</label>
                    </div>
                    <!--<div class="row a1">
      <label class="margin-bottom-0px f3">DM, MD, MBBS</label>
    </div>-->
                    <div class="row a1">
                      <label class="margin-bottom-0px f3">{{SelectedDoctorData.UserName}}</label>
                    </div>
                    <div class="row">
                      <a title="DeActive" class="float-right color-Rejected margin-left-10px" *ngIf="SelectedDoctorData.UserActivationStatus == 'DeActive'"> Account is Disabled</a>
                    </div>
                  </div>
                  

                </div>
               
              
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-5">
                    <!--<ul class="nav nav-tabs nav-tab-ivf " id="tabContent">

    <li class="active col text-align-center"><a class="nav-item4 active" href="#Test" data-toggle="tab">Profile</a></li>
    <li class="col text-align-center"><a class="nav-item4" href="#Changep" data-toggle="tab">Change Password</a></li>
    <li class="col text-align-center"><a class="nav-item4" href="#Activity" data-toggle="tab">Role</a></li>

  </ul>-->
                    <!--<div class="tab-content">
    <div class="tab-pane active" id="Test">

    </div>

    <div class="tab-pane" id="Changep">

    </div>

    <div class="tab-pane" id="Activity">

    </div>
  </div>-->
                    <form class="form " novalidate="" (ngSubmit)="onChangePassword()" #f="ngForm">

                      <div class="card margin-top-10">
                        <div class="card-header wh-header">
                          <div class="row">
                            <div class="col-md-6">
                              <label>Change Password</label>
                            </div>
                            <div class="col-md-6">
                              <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
                            </div>
                          </div>
                        </div>

                        <div class="card-body margin-left-zero padding-left-0px padding-right-0px ">
                          <div class="row margin-left-auto">
                            <div class="col-md-12 padding-l-0px">


                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Reset Password</label>
                                    </div>


                                    <div class="col-md-4">
                                      <input type="password" class="form-control  border-bottom-tbl"
                                             name="CurrentChangePasswordRequest.NewPassword"
                                             id="CurrentChangePasswordRequest.NewPassword" pattern="^[\sa-zA-Z0-9,._\-?,$@!%*?&]*$"
                                             placeholder="Password" [(ngModel)]="CurrentChangePasswordRequest.NewPassword" required #NewPassword="ngModel" minlength="8" maxlength="15">

                                      <small class="form-text text-danger"
                                             *ngIf="(!NewPassword.valid && (NewPassword.dirty || NewPassword.touched)  && NewPassword.errors.minlength && !isRequesting)">(Mininum 8 Chars)</small>
                                    </div>



                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Status</label>
                                    </div>
                                    <div class="col-md-4">
                                      <CodeTypeValue CodeType="CNTR"></CodeTypeValue>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Choose Roles</label>
                                    </div>
                                    <div class="col-md-4">
                                      <input type="text" class="form-control  border-bottom-tbl" placeholder="Choose Roles"
                                             pattern="^[\0-9,._\-?]*$">
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-8 margin-tg-auto ">
                                      <div class="table-component">
                                        <div class="table-responsive overflow-x">


                                          <table class="table table-striped margin-left-zero width-100pe bk-color-lightgray"
                                                 cols="auto,2*,*,*,*,*,*,*">

                                            <thead class="">
                                              <tr>

                                                <th class="">
                                                  Select
                                                </th>

                                                <th class="">
                                                  Roles
                                                </th>

                                              </tr>
                                            </thead>

                                            <tbody class="table-body">
                                              <tr>

                                                <td class=" td-padding-tb">
                                                  <input type="checkbox" class="width-15px">
                                                </td>                                                
                                                <td class="td-padding-tb">Top Level Management</td>

                                              </tr>
                                              <tr>

                                                <td class=" td-padding-tb">
                                                  <input type="checkbox" class="width-15px">
                                                </td>
                                                <td class="td-padding-tb">Top Level Management</td>

                                              </tr>

                                            </tbody>

                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                    
                                  </div>
                                </div>
                              </div>

                              <div class="row" hidden>
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px">Re-Enter New Password</label>
                                    </div>
                                    <div class="col-md-4">

                                      <input type="password" class="form-control  border-bottom-tbl"
                                             name="CurrentChangePasswordRequest.ReEnterPassword"
                                             id="CurrentChangePasswordRequest.ReEnterPassword" pattern="^[\sa-zA-Z0-9,._\-?,$@!%*?&]*$"
                                             placeholder="Re-Enter New Password" [(ngModel)]="CurrentChangePasswordRequest.ReEnterPassword" required #ReEnterPassword="ngModel" minlength="8" maxlength="15">

                                      <small class="form-text text-danger"
                                             *ngIf="(!ReEnterPassword.valid && (ReEnterPassword.dirty || ReEnterPassword.touched)  && ReEnterPassword.errors.minlength && !isRequesting)">(Mininum 8 Chars)</small>
                                      <!--<input type="text" class="form-control" placeholder="Test"
                 id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                 [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                 name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                 maxlength="100" required>
          <small class="form-text text-danger"
                 *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
          <small class="form-text text-danger"
                 *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                      <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                   id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                   [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                   name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
          </CustomDataByRequestType>-->
                                    </div>

                                  </div>

                                </div>
                              </div>








                            </div>
                          </div>
                        </div>

                      </div>
                    </form>
                  </div>
                </div>
               
              </div>
              </div>
          </div>

         
        </div>
      </div>

     
      

      <!--<div class="row" *ngIf="SelectedService">

  TESTING  {{SelectedService.Code}}
  </div>-->



    </div>
      </div>

    </div>


